import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import useGateway from 'shared/hooks/useGateway'
import useToken from 'token/shared/hooks/useToken'
import { NodeModel } from 'token/shared/types'

function TokenContainer() {
  const { tokenUuid } = useParams()

  const { token, metadata, isFetching } = useToken({ tokenUuid })

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const hideInteractionContainer =
    searchParams.has('hideInteractionContainer') ?? false

  const [currentNodeModel, setCurrentNodeModel] = useState<NodeModel>()

  const interactionModelUuid =
    currentNodeModel && currentNodeModel.type === 'interaction_task_nodemodel'
      ? currentNodeModel?.handler?.interactionmodel_uuid
      : ''

  useEffect(() => {
    if (!token || !token.execution_state) return

    const { nodes, flow_elementmodels } = token.execution_state

    const { nodemodels } = flow_elementmodels

    if (!nodes || nodes.length === 0) return

    const activeNode = nodes.at(-1)

    if (!activeNode) return

    const nodemodel = nodemodels.find(
      ({ uuid }) => uuid === activeNode.nodemodel_uuid
    )

    setCurrentNodeModel(nodemodel)
  }, [token])

  const { navigateToForwardURL, navigateToTaskScreen } = useGateway()

  useEffect(() => {
    if (!interactionModelUuid) {
      const hasForwardURL = navigateToForwardURL(metadata)
      if (!hasForwardURL) {
        navigateToTaskScreen(token?.process_uuid)
      }

      return
    }

    const navigateURL =
      `/interaction/${tokenUuid}/${interactionModelUuid}` +
      `${hideInteractionContainer ? `?hideInteractionContainer=true` : ''}`

    navigate(navigateURL, { replace: true })
  })

  if (isFetching) {
    return null
  }

  return <div>{tokenUuid}</div>
}

export default TokenContainer
